<app-tool-list
  [tableData]="data"
  [defaultSortOrder]="defaultSortOrder"
  [tableFilters]="filters"
  [moreFilters]="moreFilters"
  [searchParams]="searchParams"
  [toolExportParams]="toolExportParams"
  dataType="tools"
  source="tools"
  modelId="0"></app-tool-list>

<app-tool-transfer></app-tool-transfer>
